import { z } from 'zod';

export type PasswordErrorMessages = {
  required?: string;
  minLength?: string;
  uppercaseLetter?: string;
  number?: string;
  specialCharacter?: string;
};

const DEFAULT_ERROR_MESSAGES = {
  required: 'Password is required',
  minLength: `Password must be at least ${10} characters`,
  uppercaseLetter: 'Password must include an uppercase letter',
  number: 'Password must include a number',
  specialCharacter: 'Password must include a special character',
};

export const createPasswordSchema = (customErrorMessages: Partial<PasswordErrorMessages> = {}) => {
  const errorMessages = { ...DEFAULT_ERROR_MESSAGES, ...customErrorMessages };
  return z
    .string()
    .min(1, errorMessages.required)
    .min(10, errorMessages.minLength)
    .regex(/[A-Z]/, errorMessages.uppercaseLetter)
    .regex(/\d/, errorMessages.number)
    .regex(/[!@#$%^&*(),.?":{}|<>_+=\-[\]]/, errorMessages.specialCharacter);
};

export type SigninPasswordErrorMessages = {
  minLength?: string;
};

const DEFAULT_SIGNIN_ERROR_MESSAGES = {
  minLength: `Password must be at least ${8} characters`,
};

export const createSigninPasswordSchema = (customErrorMessages: Partial<SigninPasswordErrorMessages> = {}) => {
  const errorMessages = { ...DEFAULT_SIGNIN_ERROR_MESSAGES, ...customErrorMessages };

  return z.string().min(8, errorMessages.minLength);
};
